// extracted by mini-css-extract-plugin
module.exports = {"table":"TrafficLocationsResultTable_table_pZmO2","root":"TrafficLocationsResultTable_root_1EnKv"};